import { enableProdMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { Amplify } from "aws-amplify";
import aws_exports from "./aws-exports";
import { providePhoenixIconFonts } from "@kehe/phoenix-theme";

Amplify.configure(aws_exports);

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule, {
    applicationProviders: [
      providePhoenixIconFonts(), // Preloads Icons to prevent pop-in issue of Fontawesome glyphs
      provideZoneChangeDetection(),
    ],
  })
  .catch((err) => console.log(err));
